import React from "react";
import { IconProps } from "./props";

export const OdometerIcon: React.FC<IconProps> = ({
  size = 24,
  fill = "#000000",
  strokeWidth = 1,
  strokeColor = "#000000",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill={fill}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      className={className}
      version="1.1"
      width={size}
      height={size}
      viewBox="0 0 501.015 501.015"
      xmlSpace="preserve"
    >
      <g>
        <path
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          d="M242.105,115.922L242.105,115.922h-0.006V96.015V56.188h0.006h16.804v59.734h-0.018v0.012l-8.391-0.012H242.105z M39.555,317.098l41.919-7.389l16.908-2.979v-0.012h0.006l-1.478-8.334l-1.442-8.193h-0.006v-0.012l-58.83,10.368L39.555,317.098z M411.266,169.234l-30.228,17.437v0.012l0,0l4.663,8.086l3.735,6.452l0,0l51.731-29.864l-8.405-14.549L411.266,169.234z M150.24,390.923l-6.623-5.556l0,0l0,0l-38.402,45.749l12.879,10.805l16.71-19.919l21.687-25.842l0,0L150.24,390.923z M432.562,386.81l8.394-14.559l-18.046-10.421l-33.673-19.458v0.012l0,0l-4.641,8.027l-3.753,6.514l0,0v0.012L432.562,386.81z M36.703,242.282l20.98,3.686l37.84,6.69v-0.012h0.006l2.5-14.215l0.405-2.329v-0.012l-58.827-10.382L36.703,242.282z M461.04,226.158l-15.989,2.813l-42.841,7.542v0.012h-0.006l2.163,12.256l0.757,4.279l0,0v0.012l58.836-10.367L461.04,226.158z M189.346,128.104v0.012l13.636-4.974l2.143-0.78h0.006l-20.422-56.14l-15.791,5.757l2.911,8.003L189.346,128.104L189.346,128.104z M67.814,386.431l51.725-29.86v-0.012l0,0l-6.469-11.201l-1.93-3.346l0,0l0,0l-51.734,29.861l8.402,14.552h0.006V386.431z M343.782,396.432l38.396,45.773L395.04,431.4v-0.012l-38.385-45.762v0.012v-0.012l-8.931,7.495L343.782,396.432L343.782,396.432z M59.625,170.992L59.625,170.992l51.731,29.876l0,0l7.276-12.613l1.12-1.936v-0.012l-51.731-29.864L59.625,170.992z M463.877,300.973L463.877,300.973l-58.824-10.379l-0.626,3.547l-2.294,13.004l58.83,10.379L463.877,300.973z M118.408,101.05 l-12.868,10.802l14.109,16.81l24.291,28.948l0,0l0,0l7.601-6.384l5.26-4.412l0,0l0.006-0.012L118.408,101.05z M311.249,80.203 L295.846,122.5l0.012,0.012l0,0l10.521,3.818l5.261,1.912l0,0h0.006l20.434-56.126l-15.794-5.742L311.249,80.203z M353.712,155.154 l3.263,2.731l0,0l0,0l38.402-45.767l-12.873-10.79h-0.006l0,0l-38.396,45.752l0,0v0.012L353.712,155.154z M250.507,27.021 C112.382,27.021,0,139.394,0,277.531c0,79.57,37.333,150.535,95.361,196.462h25.36C57.036,431.778,14.939,359.49,14.939,277.531 c0-129.896,105.673-235.568,235.567-235.568c129.898,0,235.571,105.672,235.571,235.568c0,81.959-42.097,154.247-105.785,196.462 h25.363c58.02-45.927,95.358-116.892,95.358-196.462C501.015,139.399,388.633,27.021,250.507,27.021z"
        />
      </g>
    </svg>
  );
};
